import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

// the frame the whole webview treats as a screen of its own
const MODAL_FRAME = 'modal'

// Turbo Drive replaces the body on render, so a visible overlay leaves with the old page.
export default class extends Controller {
  connect() {
    this.onVisit = (event) => this.start(event)
    this.onSubmit = (event) => this.submit(event)
    this.onSettled = () => this.stop()

    document.addEventListener('turbo:visit', this.onVisit)
    document.addEventListener('turbo:submit-start', this.onSubmit)
    document.addEventListener('turbo:before-render', this.onSettled)
    document.addEventListener('turbo:before-stream-render', this.onSettled)
    document.addEventListener('turbo:submit-end', this.onSettled)
    document.addEventListener('turbo:load', this.onSettled)
    document.addEventListener('turbo:fetch-request-error', this.onSettled)
  }

  disconnect() {
    clearTimeout(this.timeout)

    document.removeEventListener('turbo:visit', this.onVisit)
    document.removeEventListener('turbo:submit-start', this.onSubmit)
    document.removeEventListener('turbo:before-render', this.onSettled)
    document.removeEventListener('turbo:before-stream-render', this.onSettled)
    document.removeEventListener('turbo:submit-end', this.onSettled)
    document.removeEventListener('turbo:load', this.onSettled)
    document.removeEventListener('turbo:fetch-request-error', this.onSettled)
  }

  // Turbo submits a data-turbo-stream link instead of visiting it, copying the link's frame onto
  // the form it builds — so this one event covers both links and real forms.
  submit({ detail }) {
    const submission = detail?.formSubmission
    const frame =
      submission?.submitter?.dataset.turboFrame ||
      submission?.formElement?.dataset.turboFrame
    if (!this.navigates(frame)) return

    this.start({ detail: { action: 'advance' } })
  }

  // No frame replaces the screen, the modal frame replaces the sheet's screen: both are a
  // navigation. Anything aimed at a frame of its own is a piece of the screen being refreshed,
  // and those already wait behind their own skeleton.
  navigates(frame) {
    return !frame || frame === MODAL_FRAME
  }

  start({ detail }) {
    // 'replace' re-renders the screen on display: covering it would hide what is being read
    if (detail?.action === 'replace') return

    clearTimeout(this.timeout)
    this.timeout = setTimeout(
      () => this.element.classList.add('is-active'),
      this.delay
    )
  }

  stop() {
    clearTimeout(this.timeout)
    this.element.classList.remove('is-active')
  }

  // Turbo's own threshold: the loader waits exactly as long as the bar it stands in for
  get delay() {
    return Turbo.config.drive.progressBarDelay
  }
}
